<template>
  <div>
    <div class="progressbar">
      <div class="progressbar_sup">
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: ['progress'],
    watch: {
      progress () {
        this.$nextTick(() => {
          const progressbarSup = document.querySelector(`.progressbar_sup`)
          progressbarSup.style.width = `${this.progress * 100}%`
        })
      }
    }
  }
</script>
<style scoped>
  .progressbar {
    position: relative;
    width: 100%;
    height: 8px;
    border-radius: 4px;
    background-color: #eaeaea;
  }
  .progressbar_sup{
    position: absolute;
    top: 0;
    left: 0;
    width: 0;
    height: 100%;
    border-radius: 4px;
    background: linear-gradient(#ffa06a, #ff3e36)
  }
</style>



// WEBPACK FOOTER //
// index.vue?689cb494